import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { PiShuffleFill as ShuffleIcon } from 'react-icons/pi';

const TimePicker = ({
  closeModal,
  setCurrentTab,
  dettagliNodi,
  selectedNode,
  setDettagliNodi,
  handleOpenModal,
}) => {
  const [selectedVariable, setSelectedVariable] = useState(null);

  useEffect(() => {
    if (selectedNode) {
      const widgetData = dettagliNodi[`nodo-${selectedNode.id}`]?.widget || {};

      const widgetObject = Object.fromEntries(Object.entries(widgetData));

      setSelectedVariable(
        widgetObject?.variable_name
          ? {
              value: widgetObject.variable_name,
              label: widgetObject.variable_name,
            }
          : null
      );
    }
  }, [selectedNode, dettagliNodi]);

  const handleChange = (selectedOption) => {
    setSelectedVariable(selectedOption);

    const updatedWidget = {
      type: 'time',
      variable_name: selectedOption?.value || null,
      variable_required: !!selectedOption,
    };

    const updatedNode = {
      ...dettagliNodi[`nodo-${selectedNode.id}`],
      widget: updatedWidget,
    };

    setDettagliNodi((prev) => ({
      ...prev,
      [`nodo-${selectedNode.id}`]: updatedNode,
    }));
  };

  const nodeVariables =
    dettagliNodi?.[`nodo-${selectedNode?.id}`]?.node_variables || [];

  const variable_options = nodeVariables.length
    ? [
        { value: null, label: 'Nessuna variabile' },
        ...nodeVariables.map((variable) => ({
          value: variable.nome_variabile,
          label: variable.nome_variabile,
        })),
      ]
    : [{ value: '', label: 'Nessuna variabile disponibile' }];

  return (
    <div className="row" style={{ height: '530px' }}>
      <div className="col-12" style={{ borderLeft: '1px black solid' }}>
        <div className="d-flex flex-column ps-1" style={{ height: '100%' }}>
          <div className="flex-grow-1">
            <label
              htmlFor="selezionaAzioneRapida"
              className="d-flex gap-2 align-items-center"
            >
              <ShuffleIcon className="fs-4" />
              Seleziona variabile
            </label>
            <p className="text-secondary mb-2">Collega variabile al widget</p>

            <Select
              options={variable_options}
              value={selectedVariable}
              onChange={handleChange}
              placeholder="Cerca..."
              isSearchable
            />
          </div>

          <div className="mt-auto d-flex align-items-center gap-2 justify-content-between">
            <button
              className="btn bg-green-second text-white px-4"
              onClick={handleOpenModal}
            >
              Crea nuova variabile
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimePicker;
